<div side="left" class="dashboard-side-pane__list-wrapper">
  <div class="dashboard-side-pane__action-list-container">
    <div class="dashboard-side-pane__header">
      <div class="dashboard-side-pane__header-title-wrapper">
        <h3 class="dashboard-side-pane__label">{{ headerText }}</h3>

        @if (headerIconTooltip) {
          @if (!isLoading) {
            <a class="no-style right-align" [href]="headerIconUrl" target="_blank">
              <xi-icon-button
                icon="info"
                color="CX"
                [hasAnimation]="false"
                [fill]="'no-fill'"
                [tooltip]="{ text: headerIconTooltip }"
              >
              </xi-icon-button>
            </a>
          }
        }
      </div>

      @if (isEditable && (items.length !== 0 || itemType === 'savedView')) {
        <xi-fab
          icon="fab_plus"
          color="orca"
          buttonSize="normal"
          [tooltip]="fabTooltip"
          (onClick)="addItem()"
          [disabled]="!!isDisabled || !!addButtonDisabled"
        >
        </xi-fab>
      }
    </div>

    <div
      class="dashboard-side-pane__scroll"
      [ngClass]="
        isDashboardUnsaved
          ? 'dashboard-side-pane__scrollbar--unsaved'
          : 'dashboard-side-pane__scrollbar--saved'
      "
    >
      @if (itemType === 'savedView') {
        <div class="dashboard-side-pane__search">
          <xi-search-box
            [placeholder]="searchPlaceholder || 'Search'"
            (onChangeOverride)="onSearchChange($event.detail.searchText)"
            [value]="searchText"
            [hasOutline]="false"
          ></xi-search-box>
        </div>
      }

      @if (items.length > 0 && !isLoading) {
        <div>
          <xi-list [hasSearch]="false" [hasDragging]="false" [hasBorder]="false" size="large">
            <div slot="children">
              @for (item of filteredItems; track item.id) {
                <div
                  class="dashboard-side-pane__list-item-container"
                  [class.dashboard-side-pane__list-item-container--saved-view]="
                    itemType === 'savedView'
                  "
                  [class.dashboard-side-pane__list-item-container--saved-view-active]="
                    itemType === 'savedView' && item.isActive
                  "
                >
                  <xi-list-item
                    [checked]="itemType === 'savedView' && item.isActive"
                    [attr.id]="item.id"
                    [value]="item.id"
                  >
                    <div slot="children" class="dashboard-side-pane__list-item-text">
                      <ng-container #itemTpl></ng-container>
                    </div>
                  </xi-list-item>
                </div>
              }
            </div>
          </xi-list>
        </div>
      }

      @if (items.length === 0 && !isLoading) {
        <div>
          @if (itemType === 'savedView') {
            <div class="dashboard-side-pane__empty-saved-views">
              {{ emptyMessage }}
            </div>
          } @else {
            <app-empty-side-panel
              [emptyViewSvg]="emptyViewSvg"
              [emptyViewText]="emptyViewText"
              [emptyViewTitle]="emptyViewTitle"
              [ctaButtonText]="ctaButtonText"
              [isCtaBtnDisabled]="isDisabled || addButtonDisabled"
              [showCtaButton]="isEditable"
              (ctaButtonClick)="addItem()"
            ></app-empty-side-panel>
          }
        </div>
      }
    </div>
  </div>
</div>
